import React from "react";

import SearchInput from "./SearchInput";

const ExtendShopifyTrial = ({ trialDaysToExtend, onChange }) => (
  <>
    <SearchInput
      type="text"
      placeholder="Trial days to extend"
      name="trialDaysToExtend"
      value={trialDaysToExtend}
      onChange={onChange}
    />
    <p className="mt-4 ml-4 font-medium text-xs">
      This action is irreversible, once trial is extended we cannot reduce the
      trial days/trial end date. so please make sure that you pass in correct
      days that needs to be extended. For example today is 3rd June 2025, and
      merchant is already on trial with end date as 10th June 2025. Now if you
      extend trial by 10 days, the new trial date would be 20th June 2025.
    </p>
  </>
);

export default ExtendShopifyTrial;
